<template>
    <div class="logo">
      <div>Robin Jünkersfeld</div>
      <div class="d-flex justify-content-end">
          <span class="subtext">Editor</span>
          <span class="subtext">&nbsp;&amp;</span>
          <span class="subtext logo-active">&nbsp;Colorist</span>
      </div>
    </div>
</template>

<script>
export default {
    name: 'SidebarLeft',

}
</script>